import React from 'react'
import DigidApp from '../../components/DigidApp'
import SearchCard from '../../components/SearchCard';
import Popular from './Popular';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby'
import _ from 'lodash'

const EmbedBlock = ({ entity }) => {
  const { t } = useTranslation()
  const smallPadding = entity.fieldClassName === 'small-padding'

  switch(entity.fieldBlockName) {
    case "digid_app":
      let title = t('digid_app.default_title')

      const data = useStaticQuery(graphql`
        query {
          file(relativePath: { eq: "app-min.jpg" }) {
            childImageSharp {
              gatsbyImageData(width: 1000)
            }
          }
        }
      `)

      if (entity.fieldTitle) {
        title = entity.fieldTitle
      }

      return <DigidApp
        title={title}
        text={t('digid_app.default_text')}
        backgroundImage={_.get(data, 'file.childImageSharp', null)}
        small="4"
        medium="2"
        />
    case "search":
      return <SearchCard title={entity.fieldTitle} />
    case "popular":
      return <Popular title={entity.fieldTitle} smallPadding={smallPadding} />
    default:
      return <div>Not implemented: {entity.fieldBlockName}</div>
  }
}

export default EmbedBlock
